module.exports = new __parcel__URL__("4.d0e36cdd.png").toString();